import mixpanel from 'mixpanel-browser'

mixpanel.init('662d5b935f71cb651f405c4e014b536b')

export default mixpanel